import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid
} from '@material-ui/core';

const styles = () => ({
    displayFlex: {
        display: 'flex',
    },
    verticalSpace: {
        margin: '25px 0px 20px 30px',
    },
    clearButtonSpace: {
        margin: '25px 50px 20px 0px',
    },
});

const ResetButton = (props) => {
    const {
        classes,
        setRecordId,
        setMemo,
        setCreationDate,
        setAddress,
        setReportDate,
        setEndFlg,
        setSelectCategory,
        setSelectShubetsu,
        setDisplayCategory,
        setDisplayShubetsu,
        setShubetsuList,
        setData
    } = props;

    const clearUserDatas = () => {
        setRecordId('');
        setMemo('');
        setCreationDate('');
        setAddress('');
        setReportDate('');
        setEndFlg([]);
        setShubetsuList([]);
        setSelectCategory([]);
        setSelectShubetsu([]);
        setDisplayShubetsu([]);
        setDisplayCategory([]);
        setData([]);
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.clearButtonSpace} variant="contained" onClick={() => clearUserDatas()}>リセット</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
};

ResetButton.propTypes = {
    classes: PropTypes.object.isRequired,
    setRecordId: PropTypes.func.isRequired,
    setMemo: PropTypes.func.isRequired,
    setCreationDate: PropTypes.func.isRequired,
    setAddress: PropTypes.func.isRequired,
    setReportDate: PropTypes.func.isRequired,
    setEndFlg: PropTypes.func.isRequired,
    setSelectCategory: PropTypes.func.isRequired,
    setSelectShubetsu: PropTypes.func.isRequired,
    setDisplayShubetsu: PropTypes.func.isRequired,
    setDisplayCategory: PropTypes.func.isRequired,
    setShubetsuList: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
};

export default withStyles(styles)(ResetButton);